<script>
  import { Game, Gamer } from './game.js'
  let game = new Game()
  let gamers = []
  let gamelog = []

  // Event Related
  let actioner
  let action = 'guess_fail'
  let targets = []
  let position = 0

  // History
  let history = []
  function snapshot() {
    history.push({
      game: JSON.stringify(game),
      gamers: JSON.stringify(gamers),
      gamelog: JSON.stringify(gamelog)
    })
    localStorage.setItem('history', JSON.stringify(history))
  }
  function revert() {
    console.log(history)
    history.pop()
    restore()
  }

  function restore() {
    if (history.length == 0) {
      console.log('No more history')
      gamers = []
      game = new Game()
      gamelog = []
      localStorage.setItem('history', JSON.stringify(history))
      return
    }
    let snapshot = history[history.length - 1]
    if (snapshot) {
      let gameJSON = JSON.parse(snapshot.game)
      let gamersJSON = JSON.parse(snapshot.gamers)
      game = Object.assign(new Game(), gameJSON)
      gamersJSON.forEach((g) => {
        gamers[g.id] = Object.assign(new Gamer(), g)
      })
      gamelog = JSON.parse(snapshot.gamelog)
    }
    localStorage.setItem('history', JSON.stringify(history))
  }

  function performAction() {
    if (!actioner) {
      console.log('No actioner, skip')
      return
    }
    let didAction = false
    switch (action) {
      case 'guess_fail':
        game.cardEvent(actioner, [])
        game = game
        gamers[actioner.id] = actioner
        gamelog = [
          ...gamelog,
          `【${actioner.name}】出牌但未猜中, 资金->${actioner.money}，手牌->${actioner.card}，奖池->${game.rewardPool}`
        ]
        didAction = true
        break
      case 'guess_win':
        game.cardEvent(actioner, targets)
        game = game
        gamers[actioner.id] = actioner
        targets.forEach((target) => {
          gamers[target.id] = target
        })
        gamelog = [
          ...gamelog,
          `【${actioner.name}】出牌猜中【${targets
            .map((t) => t.name)
            .join(',')}】, 资金->${actioner.money}，手牌->${
            actioner.card
          }，奖池->${game.rewardPool}`
        ]
        didAction = true
        break
      case 'gambling':
        game.gamblingEvent(actioner, position)
        game = game
        gamers[actioner.id] = actioner
        gamelog = [
          ...gamelog,
          `【${actioner.name}】在位置${position}下注，资金->${actioner.money}，奖池->${game.rewardPool}`
        ]
        didAction = true
        break
      case 'wrong_card':
        game.wrongCardEvent(actioner)
        game = game
        gamers[actioner.id] = actioner
        gamelog = [
          ...gamelog,
          `【${actioner.name}】有错误答案，资金->${actioner.money}，奖池->${game.rewardPool}`
        ]
        didAction = true
        break
      default:
        break
    }
    if (didAction) {
      snapshot()
      action = 'guess_fail'
      targets = []
      position = 0
    }
  }

  function endRound() {
    let logp1 = `[回合结束] 结束时奖池为${
      game.rewardPool
    }+${game.getRoundReward()}(本轮奖励)=${
      game.rewardPool + game.getRoundReward()
    }`
    let winners = game.roundEnd(gamers)
    game = game
    gamers = gamers
    if (winners.length > 0) {
      let logp2 = `，赢家为${winners
        .map((w) => {
          return `${w.name}｜资金->${w.money}`
        })
        .join(', ')}`
      gamelog = [...gamelog, logp1 + logp2]
    } else {
      gamelog = [...gamelog, logp1]
    }
    snapshot()
  }

  // Gamer Add
  let gamerNameInput = ''
  function addGamer() {
    let newGamer = new Gamer(gamers.length, gamerNameInput)
    gamers = [...gamers, newGamer]
    console.log('新增玩家:', newGamer.name)
    console.log(gamers)
    gamerNameInput = ''
  }

  function initGamers() {
    gamers = [
      new Gamer(0, '轴伊'),
      new Gamer(1, 'MIYU'),
      new Gamer(2, '夜宫'),
      new Gamer(3, '友夏'),
      new Gamer(4, '茶冷'),
      new Gamer(5, '闹闹'),
      new Gamer(6, '阿良')
    ]
    console.log('初始化玩家:', gamers)
  }

  function initGame() {
    if (localStorage.getItem('history')) {
      history = JSON.parse(localStorage.getItem('history'))
      if (history.length > 0) {
        console.log('LocalHistory Detected')
        console.log(history)
        restore()
      }
    }
  }
  initGame()

  document.body.addEventListener('keydown', (e) => {
    if (e.key == 'Enter') {
      addGamer()
    }
  })
</script>

<main>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col">
                <div class="input-group mb-3">
                  <span class="input-group-text">玩家名</span>
                  <input
                    type="text"
                    class="form-control"
                    bind:value={gamerNameInput}
                  />
                </div>
              </div>
              <div class="col">
                <button on:click={addGamer} class="btn btn-primary"
                  >新增玩家</button
                >
                <button on:click={initGamers} class="btn btn-primary"
                  >一键添加</button
                >
              </div>
            </div>
            <table class="table table-sm" style="min-height: 300px;">
              <thead>
                <tr>
                  <th scope="col">名称</th>
                  <th scope="col">资金</th>
                  <th scope="col">手牌</th>
                </tr>
              </thead>
              <tbody>
                {#each gamers as gamer}
                  <tr>
                    <td>{gamer.name}</td>
                    <td>{gamer.money}</td>
                    <td>{gamer.card}</td>
                  </tr>
                {/each}
              </tbody>
            </table>
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">操作</h3>
                <div class="row">
                  <div class="col col-3">
                    <form>
                      <div class="mb-3">
                        <label for="">玩家</label>
                        <select bind:value={actioner} class="form-select">
                          {#each gamers as gamer}
                            <option value={gamer}>{gamer.name}</option>
                          {/each}
                        </select>
                      </div>
                      <div class="mb-3">
                        <label for="">事件</label>
                        <select bind:value={action} class="form-select">
                          <option value="guess_fail">行动:未猜中</option>
                          <option value="guess_win">行动:猜中</option>
                          <option value="gambling">行动:下注</option>
                          <option value="wrong_card">其它:错误答案</option>
                        </select>
                      </div>
                      <div class="mb-3">
                        {#if action === 'gambling'}
                          <label for="position">
                            赌注位置
                            <input
                              type="number"
                              name="position"
                              bind:value={position}
                              style="width: 100px"
                            />
                          </label>
                        {/if}
                      </div>
                    </form>
                  </div>
                  <div class="col">
                    {#if action === 'guess_win'}
                      <label for=""> 被猜中玩家 </label>
                      {#each gamers as gamer}
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            bind:group={targets}
                            value={gamer}
                          />
                          <label class="form-check-label" for="">
                            {gamer.name}
                          </label>
                        </div>
                      {/each}
                    {/if}
                  </div>
                </div>
                <div style="display: flex; justify-content:space-between;">
                  <button on:click={performAction} class="btn btn-primary"
                    >操作</button
                  >
                  <button on:click={endRound} class="btn btn-danger ml-3"
                    >本轮结束</button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <ul class="list-group">
              <li class="list-group-item">当前回合：{game.round}</li>
              <li class="list-group-item">奖池金额：{game.rewardPool}</li>
              <li class="list-group-item">本轮猜中数：{game.wincount}</li>
              <li class="list-group-item">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th scope="col">位置</th>
                      <th scope="col">下注玩家</th>
                    </tr>
                  </thead>
                  <tbody>
                    {#each game.gambingRecord as record, index}
                      <tr>
                        <td>{index}</td>
                        <td>{record.map((g) => gamers[g].name).join(', ')}</td>
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h3 class="card-title">游戏日志</h3>
      <button on:click={revert}>回退一步</button>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">顺序</th>
            <th scope="col">内容</th>
          </tr>
        </thead>
        <tbody>
          {#each gamelog as log, index}
            <tr>
              <th scope="row">{index + 1}</th>
              <td>{log}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </div>
</main>

<style>
  .card {
    margin: 30px;
  }
</style>
